import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ProjectResourcesPage } from '../modules/ProjectResources';
import { projectResourceTabs } from '../modules/ProjectResources/constants';

export const Route = createFileRoute('/projectResources')({
  validateSearch: z.object({
    projectResourceTab: z.enum(projectResourceTabs).catch(projectResourceTabs[0]),
    // Prefills the Permit tab's Job # (e.g. "Request permit" on the Project Dashboard).
    jobNumber: z.coerce.number().int().positive().optional().catch(undefined),
  }),
  component: ProjectResourcesPage,
  head(ctx) {
    return {
      meta: [{ title: 'Project Forms' }],
    };
  },
});
